import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Modal, OverlayTrigger, Popover, Tooltip } from "react-bootstrap";
import Styles from "./Wishlist.module.css";
import del from "../../../Assets/delete.svg";
import { TabTitle } from "../../../Utility/TabTitle";
import {
  cartListService,
  removeWishlistService,
} from "../../../Services/ApiServices";
import emptyImg from "../../../Assets/no_image.svg";
import LeftArrow from "../../../Assets/modal_left_arrow.png";
import RightArrow from "../../../Assets/modal_right_arrow.png";
import { handleWishlistCount } from "../../../Redux/Action";

export default function Wishlist() {
  TabTitle("KSTORE - Wishlist");
  const dispatch = useDispatch();
  const wishlistCount = useSelector((state) => state.wishlistCount);
  const [wishlistData, setWishlistData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState({
    status: false,
    id: "",
  });
  useEffect(() => {
    handleCart();
  }, []);

  const handleCart = (data) => {
    setIsLoader(true);
    let pageNum;
    if (data === undefined) {
      pageNum = 1;
    } else {
      pageNum = data.selected + 1;
    }
    let formData = new FormData();
    formData.append("cart_type", 2);
    cartListService(formData, pageNum, 10)
      .then((res) => {
        setWishlistData(res.data);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast("Something went wrong!!", { type: "error" });
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleClearCart = (id) => {
    removeWishlistService(parseInt(id))
      .then((res) => {
        toast(res.data, { type: "success" });
        let filterCartList = wishlistData.items.filter((e) => e.cart_id !== id);
        setWishlistData({ ...wishlistData, items: filterCartList });
        dispatch(handleWishlistCount(wishlistCount - 1));
        handleCart();
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!", { type: "error" });
        }
      });
  };

  return (
    <div className={Styles.bg}>
      {isLoader ? (
        <div className={Styles.loaderParent}>
          <div className={Styles.loader}></div>
        </div>
      ) : null}
      <div className="bg-white">
        <p className={Styles.title + " fontBold"}>
          Wish <span className="orange">List</span>{" "}
        </p>
        <div className={Styles.tableParentContainer}>
          <div className={Styles.table + " d-flex justify-content-center"}>
            <table>
              <thead>
                <tr className={Styles.heading}>
                  <th className={Styles.th + " text-center"}>S.No</th>
                  <th className={Styles.cartProductName + " text-center"}>
                    Product Name
                  </th>
                  <th className={Styles.th + " text-center"}>Category</th>
                  <th className={Styles.th + " text-center"}>Sub Category</th>
                  <th className={Styles.th + " text-center"}>Price</th>
                  <th className={Styles.cartList + " text-center"}>Action</th>
                </tr>
              </thead>
              <tbody>
                {wishlistData?.items?.map((e, index) => (
                  <tr key={e.cart_id} className={Styles.tr}>
                    <td className="text-center">
                      {(wishlistData.page - 1) * wishlistData.size +
                        (index + 1)}
                    </td>
                    <td
                      className={
                        Styles.productContainer + " contentFont text-center"
                      }
                    >
                      <div className={Styles.imgContainer}>
                        <img
                          className={Styles.img}
                          src={
                            e.product_images.length > 0
                              ? e.product_images[0].product_image
                              : emptyImg
                          }
                          alt="cart"
                        />
                      </div>
                      <div className="w-50 align-self-center">
                        <p
                          className={
                            Styles.productDetails +
                            " mb-0 contentFont text-center"
                          }
                        >
                          <OverlayTrigger
                            placement="bottom"
                            trigger={"hover"}
                            overlay={
                              <Popover className={Styles.popover}>
                                {e?.product_name}
                              </Popover>
                            }
                          >
                            <td className={" contentFont text-start"}>
                              {e.product_name.substring(0, 37)}
                              {e.product_name.length > 37 ? "..." : null}
                            </td>
                          </OverlayTrigger>
                        </p>
                      </div>
                    </td>
                    <td className="text-center contentFont">
                      {e?.category_name ? e?.category_name : "-"}
                    </td>
                    <td className="text-center contentFont">
                      {e?.sub_category_name ? e?.sub_category_name : "-"}
                    </td>
                    <td className="contentFont text-center">
                      {"₹" + e?.price.toFixed(2)}
                    </td>
                    <td className="text-center">
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip>Delete</Tooltip>}
                      >
                        <img
                          className={Styles.del}
                          src={del}
                          onClick={() => {
                            setIsConfirmation({
                              ...isConfirmation,
                              status: true,
                              id: e.product_id,
                            });
                          }}
                          alt="del"
                        />
                      </OverlayTrigger>
                    </td>
                  </tr>
                ))}
                {wishlistData?.items?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={8}
                      className="fs-6 text-center text-secondary p-3"
                    >
                      Data Not Found
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>

        <div className={Styles.cartBtnContainer + " mt-3"}>
          <div
            style={{ display: wishlistData.total <= 10 ? "none" : "block" }}
            className={Styles.cartBtnRightContainer}
          >
            <ReactPaginate
              previousLabel={<img src={LeftArrow} alt="left" />}
              nextLabel={<img src={RightArrow} alt="right" />}
              breakLabel="..."
              pageCount={Math.ceil(wishlistData.total) / 10}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={({ selected }) => handleCart(selected + 1)}
              forcePage={0}
              containerClassName={"pagination m-0"}
              pageClassName={"page-item"}
              pageLinkClassName={
                "page-link text-secondary rounded-circle bg-light pt-1 pb-1 ps-2 pe-2 ms-1 me-1 border-0 shadow-none"
              }
              previousClassName={"page-item"}
              previousLinkClassName={
                "page-link border-0 text-dark rounded-circle p-1 bg-orange shadow-none me-1"
              }
              nextClassName={"page-item "}
              nextLinkClassName={
                "page-link border-0 text-dark bg-orange p-1 rounded-circle shadow-none ms-1"
              }
              activeClassName={"active"}
            />
          </div>
        </div>
        <Modal
          size="md"
          centered
          show={isConfirmation.status}
          onHide={() => setIsConfirmation({ ...isConfirmation, status: false })}
        >
          <Modal.Body>
            <div>
              <p className="text-start kstoreFont text-secondary fs-6 fw-bold">
                Are you sure want to delete?
              </p>
              <div className={Styles.deleteConfirmationBtnContainer}>
                <div className={Styles.btnParent}>
                  <button
                    className={
                      Styles.deleteConfirmationCancelBtn +
                      " contentFont text-uppercase"
                    }
                    onClick={() =>
                      setIsConfirmation({ ...isConfirmation, status: false })
                    }
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => {
                      handleClearCart(isConfirmation.id);
                      setIsConfirmation({ ...isConfirmation, status: false });
                    }}
                    className={
                      Styles.deleteConfirmationOkBtn +
                      " contentFont text-uppercase"
                    }
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}
